module.exports = __webpack_public_path__ + "checklist_report-cf2c10463b6276c5b1deb781841c512d.png";